// extracted by mini-css-extract-plugin
module.exports = {"itemList":"ResultsList_itemList__iP39a","item":"ResultsList_item__C3SWP"};